import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PlatformType } from '../../../common';
import { ImgQuery } from '../../services';
import { getImgUrlByPlatform } from '../../utils';
import { RedeemCardComponent } from '../redeem-card/redeem-card.component';
import { GenericRedeemViewModel } from './generic-redeem.view-model';

@Component({
  selector: 'osn-shared-generic-redeem',
  templateUrl: './generic-redeem.component.html',
  styleUrls: ['./generic-redeem.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericRedeemComponent implements OnInit {
  @Input() public vm: GenericRedeemViewModel;
  @Output() public redeemButtonClick: EventEmitter<string> = new EventEmitter();
  @Output() public loginError: EventEmitter<void> = new EventEmitter();

  @ViewChild('redeemCard') public redeemCard: RedeemCardComponent;

  public imgQuery: ImgQuery;

  public ngOnInit(): void {
    const mobileImg = getImgUrlByPlatform(PlatformType.Mobile, this.vm.backgroundImageUrlsByPlatform);
    const tabletImg = getImgUrlByPlatform(PlatformType.Tablet, this.vm.backgroundImageUrlsByPlatform);
    const desktopImg = getImgUrlByPlatform(PlatformType.Web, this.vm.backgroundImageUrlsByPlatform);
    this.imgQuery = {
      XS: { url: mobileImg },
      SM: { url: tabletImg },
      MD: { url: desktopImg },
      LG: { url: desktopImg },
      XL: { url: desktopImg },
    };
  }

  public onSubmit(): void {
    this.redeemButtonClick.emit(this.vm.buttonTextEnglish);
  }

  public onLoginError(): void {
    this.loginError.emit();
  }
}
